import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import EnterStudio from "./pages/EnterStudio";
import AuthEntry from "./pages/AuthEntry";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import { RequireStudioAccess } from "./components/RequireStudioAccess";
import { EntitlementProvider } from "./lib/EntitlementContext";

const StudioRoute = () => (
  <RequireStudioAccess>
    <EnterStudio />
  </RequireStudioAccess>
);

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-zinc-100">
      <BrowserRouter>
        <EntitlementProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Navigate to="/#pricing" replace />} />
            <Route path="/login" element={<AuthEntry mode="signIn" />} />
            <Route path="/signup" element={<AuthEntry mode="signUp" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/studio" element={<StudioRoute />} />
            <Route path="/enter-studio" element={<StudioRoute />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </EntitlementProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
